/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "052b49bef9ca90df0f0646e88ca43901fd0aa2e2";
